import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomePageModule) },
  {
    path: 'shared-activities/:id',
    loadChildren: () => import('./activities/activity-play/activity-play.module').then(m => m.ActivityPlayPageModule)
  },
  {
    path: 's/activities/:id',
    loadChildren: () => import('./activities/activity-play/activity-play.module').then(m => m.ActivityPlayPageModule)
  },
  {
    path: 'shared-activities/matching/:id',
    loadChildren: () => import('./activities/matching-activity/matching-activity-play/matching-activity-play.module').then(m => m.MatchingActivityPlayPageModule)
  },
  {
    path: 'aac',
    loadChildren: () => import('./aac/aac.module').then(m => m.AacPageModule)
  },
  {
    path: 's/aac/:id-board',
    loadChildren: () => import('./aac/aac.module').then(m => m.AacPageModule)
  },
  {
    path: 'shared-aac/:id-board',
    loadChildren: () => import('./aac/aac.module').then(m => m.AacPageModule)
  },
  {
    path: 's/sentences/:id-sentence',
    loadChildren: () => import('./aac/aac.module').then(m => m.AacPageModule)
  },
  {
    path: 'shared-sentence/:id-sentence',
    loadChildren: () => import('./aac/aac.module').then(m => m.AacPageModule)
  },
  {
    path: 'activities',
    loadChildren: () => import('./activities/activities.module').then(m => m.ActivitiesPageModule)
  },
  {
    path: 'activities/:root',
    loadChildren: () => import('./activities/activities.module').then(m => m.ActivitiesPageModule)
  },
  { path: 'login', redirectTo: 'login/', pathMatch: 'full' },
  {
    path: 'login/:nextRoute',
    loadChildren: () => import('./auth/login/login.module').then(m => m.LoginPageModule)
  },
  { path: 'sign-up', redirectTo: 'sign-up/', pathMatch: 'full' },
  {
    path: 'sign-up/:nextRoute',
    loadChildren: () => import('./auth/sign-up/sign-up.module').then(m => m.SignUpPageModule)
  },
  {
    path: 'editor-tools/image-search',
    loadChildren: () => import('./editor-tools/image-search/image-search.module').then(m => m.ImageSearchPageModule)
  },
  {
    path: 'editor-tools/image-crop',
    loadChildren: () => import('./editor-tools/image-crop/image-crop.module').then(m => m.ImageCropPageModule)
  },
  {
    path: 'scan-pace',
    loadChildren: () => import('./scan/scan-pace/scan-pace.module').then(m => m.ScanPacePageModule)
  },
  {
    path: 'subscription-success',
    loadChildren: () => import('./subscription/subscription-success/subscription-success.module')
      .then(m => m.SubscriptionSuccessPageModule)
  },
  {
    path: 'subscription-plans',
    loadChildren: () => import('./subscription/subscription-plans/subscription-plans.module').then(m => m.SubscriptionPlansPageModule)
  },
  {
    path: 'subscribe/essential-plan',
    loadChildren: () => import('./subscription/subscribe/subscribe.module').then(m => m.SubscribePageModule)
  },
  {
    path: 'subscribe/pro-plan',
    loadChildren: () => import('./subscription/subscribe/subscribe.module').then(m => m.SubscribePageModule)
  },
  {
    path: 'promo/:promoCode',
    loadChildren: () => import('./subscription/subscribe-promo/subscribe-promo.module').then( m => m.SubscribePromoPageModule)
  },
  {
    path: 's/invites/:id',
    loadChildren: () => import('./invites/invites.module').then(m => m.InvitesPageModule)
  },
  {
    path: 'invites/:id',
    loadChildren: () => import('./invites/invites.module').then(m => m.InvitesPageModule)
  },
  {
    path: 'aac-home',
    loadChildren: () => import('./v2/Aac/aac-home/aac-home.module').then(m => m.AacHomePageModule)
  },
  {
    path: 'forms',
    loadChildren: () => import('./forms/forms.module').then( m => m.FormsPageModule)
  },
  {
    path: 'subscription-success-v2',
    loadChildren: () => import('./subscription/subscription-success-v2/subscription-success-v2.module').then( m => m.SubscriptionSuccessV2PageModule)
  },
  {
    path: 'professionals',
    loadChildren: () => import('./professionals-marketplace/professionals-marketplace.module').then( m => m.ProfessionalsMarketplacePageModule)
  },
  {
    path: 'profiles',
    loadChildren: () => import('./profiles/profiles.module').then( m => m.ProfilesPageModule)
  },
  {
    path: 'profile-session-sign-in',
    loadChildren: () => import('./profiles/profile-session-sign-in/profile-session-sign-in.module').then( m => m.ProfileSessionSignInPageModule)
  },
  {
    path: 's/profile-invites/:id',
    loadChildren: () => import('./profiles/profile-invite/profile-invite.module').then( m => m.ProfileInvitePageModule)
  },
  {
    // Destination the link-preview function redirects to (outside of /s/ so the
    // hosting rewrite does not loop back into the linkPreview function).
    path: 'profile-invites/:id',
    loadChildren: () => import('./profiles/profile-invite/profile-invite.module').then( m => m.ProfileInvitePageModule)
  },
  {
    path: 'accept-profile-invite/:encoded',
    loadChildren: () => import('./profiles/accept-profile-invite/accept-profile-invite.module').then( m => m.AcceptProfileInvitePageModule)
  },
  {
    path: 'ciclis',
    loadChildren: () => import('./ciclis/ciclis.module').then( m => m.CiclisPageModule)
  },
  {
    path: 'subscription-cancel-reason',
    loadChildren: () => import('./subscription/subscription-cancel-reason/subscription-cancel-reason.module').then( m => m.SubscriptionCancelReasonPageModule)
  },
  {
    path: 'user-account',
    loadChildren: () => import('./user/user-account/user-account.module').then( m => m.UserAccountPageModule)
  },
  {
    path: 'subscription-verify',
    loadChildren: () => import('./subscription/subscription-verify/subscription-verify.module').then( m => m.SubscriptionVerifyPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
